import { useState, useRef, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { setUpperPopup } from '../../store/reducers/general'
import { getNextMembers, createNewTableItem } from '../../services/util'
import { useNavigate } from 'react-router-dom'
import { videoService } from '../../services/video'
import { VideoPopup } from './popup'

export function Scripter({ role, part, status, videoId, isOpen }) {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const { currentTeam, _id } = useSelector(state => state.user)
    const original = useRef(JSON.parse(JSON.stringify(part)))
    const [scriptLink, setScriptLink] = useState(part.scriptLink || '')
    const [popup, setPopup] = useState('')
    const [items, setItems] = useState(part.items || [])
    const [notes, setNotes] = useState(part.notes || '')
    const [changeFlag, setChangeFlag] = useState(false)
    const nextMembers = useRef(getNextMembers(currentTeam, _id, 'scripter'))
    const nextMember = useRef(null)
    const linkRefs = useRef({})

    const buttons = useMemo(() => {
        const buttons = []

        if (changeFlag) {
            buttons.push(<div onClick={() => setPopup('discard-changes')} key='default' className='gray'>בטל שינויים</div>)
            buttons.push(<div onClick={() => setPopup('save-only')} key='save-only' className='save'>שמור שינויים</div>)
        }
        if (role !== 'admin') {
            buttons.push(<div onClick={() => setPopup('forward-as-success')} className='green' key='forward-as-success'>העבר כהצלחה</div>)
            buttons.push(<div onClick={() => setPopup('forward-as-failure')} className='red' key='forward-as-failure'>העבר ככשלון</div>)
        }
        else {
            if (status.status.includes('forward')) buttons.push(<div onClick={() => setPopup('returned-for-changes')} key='reject' className='red' name='returned-for-changes'>החזר אחורה לתיקון</div>)
            else {
                const next = <div className='next-wrapper' key='next'>
                    <select name='forward-to-selected' ref={nextMember}>
                        {nextMembers.current?.map(member => <option value={member._id || member.name} key={member._id || member.name}>{member.name}</option>)}
                    </select>
                    <div onClick={() => setPopup('forward-to-selected')} key='forward-to-selected' className='green' name='forward-to-selected'>העבר</div>
                </div>
                buttons.push(next)
            }
        }

        if (!buttons.length) return null
        return <div className='buttons-wrapper'>
            <p>{role === 'admin' ? 'אפשרויות' : 'הגש לבדיקה'}</p>
            <div className='buttons'>
                {buttons}
            </div>
        </div>

    }, [changeFlag, role])

    const addItem = () => {
        setItems([...items, createNewTableItem()])
        setChangeFlag(true)
    }

    const addLink = (id) => {
        try {
            new URL(linkRefs.current[id].value)
        }
        catch {
            return dispatch(setUpperPopup('invalid-link'))
        }
        let i = structuredClone(items)
        i.find(item => item.id === id).links.push(linkRefs.current[id].value)
        setItems(i)
        linkRefs.current[id].value = ''
        setChangeFlag(true)
    }

    const deleteLink = (id, idx) => {
        let i = structuredClone(items)
        i.find(item => item.id === id).links.splice(idx, 1)
        setItems(i)
        setChangeFlag(true)
    }

    const editItem = (ev, idx, key) => {
        let i = structuredClone(items)
        i[idx][key] = ev.target.value
        setItems(i)
        setChangeFlag(true)
    }

    const deleteItem = (idx) => {
        setItems(items.filter((_, i) => i !== idx))
        setChangeFlag(true)
    }

    const handleButtonClick = async (ns) => {
        setPopup('')
        if (ns === 'discard-changes') {
            setScriptLink(original.current.scriptLink)
            setNotes(original.current.notes)
            setItems(original.current.items)
            setChangeFlag(false)
            return
        }
        dispatch(setUpperPopup('loader'))
        try {
            const e = {
                scriptLink,
                notes,
                items,
            }
            const nextSteps = ns === 'forward-to-selected' ? 'forward-to-' + nextMember.current.value : ns
            const { scripter } = await videoService.editVideo({ partToEdit: 'scripter', videoId, teamId: currentTeam._id, edit: e, nextSteps })
            original.current = scripter
            dispatch(setUpperPopup('video-edited'))
            setChangeFlag(false)
            if (nextSteps === 'save-only') {
                setItems(scripter.items.map(i => ({ ...i, id: Math.random() })))
                setScriptLink(scripter.scriptLink)
                setNotes(scripter.notes)
            }
            else navigate('/')
        }
        catch {
            dispatch(setUpperPopup('errorServer'))
        }
    }

    return <form id='scripter' onInput={(ev) => { if (ev.target.name !== 'forward-to-selected') setChangeFlag(true) }}>
        {isOpen && <div className='main3-back'>
            <h3>לינק לתסריט</h3>
            <div className='link-wrapper'>
                <input readOnly={role === 'producer'} type='url' value={scriptLink} placeholder='לינק לתסריט' onChange={(ev) => setScriptLink(ev.target.value)} />
                {scriptLink && <p className='underline' onClick={() => window.open(scriptLink, '_blank')}>צפה</p>}
            </div>

            <h3 style={{ marginTop: '15px' }}>טבלת פריטים</h3>
            <div className="table-wrapper">
                <table>
                    <thead>
                        <tr>
                            <td>פריט</td>
                            <td>תיאור</td>
                            <td>קישורים</td>
                            <td>כמה הדבר חשוב?</td>
                        </tr>
                    </thead>
                    <tbody>
                        {items.map((item, idx) => <tr key={item.id}>
                            <td>
                                <input placeholder='מה צריך?' type='text' value={item.item} onChange={(ev) => editItem(ev, idx, 'item')} />
                                {(status.level === 'scripter' || role === 'admin') && <div className="delete-absolute" onClick={() => deleteItem(idx)}><span className="material-symbols-outlined">delete</span></div>}
                            </td>
                            <td>
                                <textarea placeholder='תיאור' type='text' value={item.info} onChange={(ev) => editItem(ev, idx, 'info')} />
                            </td>
                            <td>
                                <div className='table-link'>
                                    {item.links?.map((link) => <div className="single-link" key={link}>
                                        {link && <span onClick={(ev) => { ev.stopPropagation(); navigator.clipboard.writeText(link); dispatch(setUpperPopup('copied')) }} className="material-symbols-outlined">content_copy</span>}
                                        {<span className="material-symbols-outlined" onClick={(ev) => { ev.stopPropagation(); deleteLink(item.id, link) }}>delete</span>}
                                        <a href={link} target='_blank'>{link.split('://')[1]?.slice(0, 8)}</a>
                                    </div>
                                    )}
                                    <div className="link-input-wrapper">
                                        <span className="material-symbols-outlined clickable add-link" onClick={() => addLink(item.id)}>add</span>
                                        <input
                                            placeholder='https://...'
                                            type='text'
                                            ref={el => {
                                                if (el) linkRefs.current[item.id] = el
                                            }}
                                        />
                                    </div>

                                </div>
                            </td>
                            <td className={'table-status ' + (item.importance === 'עדיף שיהיה' ? 'orange' : item.importance === 'אי אפשר בלעדיו' ? 'red' : 'green')}>
                                <select className={'table-status ' + (item.importance === 'עדיף שיהיה' ? 'orange' : item.importance === 'אי אפשר בלעדיו' ? 'red' : 'green')} value={item.importance} onChange={(ev) => { editItem(ev, idx, 'importance'); setChangeFlag(true) }}>
                                    <option value='לא חובה'>לא חובה</option>
                                    <option value='עדיף שיהיה'>עדיף שיהיה</option>
                                    <option value='אי אפשר בלעדיו'>אי אפשר בלעדיו</option>
                                </select>
                            </td>
                        </tr>)}
                    </tbody>
                </table>
                <div className="add" onClick={addItem}>+ הוסף פריט</div>
            </div>


            <h3>הערות ומשוב</h3>
            <textarea className='area' value={notes} placeholder="שיח עם אדמין הצוות" onChange={(ev) => setNotes(ev.target.value)} />

            {popup && <VideoPopup close={() => setPopup('')} type={popup} onConfirm={handleButtonClick} />}
            {buttons}
        </div>}
    </form>
}